import React from "react";
import { MapPin, Phone, Globe } from "lucide-react";
import 'flag-icons/css/flag-icons.min.css';

// Custom WhatsApp Icon Component
// const WhatsAppIcon = ({ size = 50, className = "" }) => (
//   <svg
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="currentColor"
//     className={className}
//   >
//     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.051 3.488" />
//   </svg>
// );

export default function Location() {
  return (
    <section className="py-20 w-full bg-gradient-to-br from-white to-gray-50">
      <div className="bl-container">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Global Presence
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We serve clients worldwide with offices strategically located across
            different continents
          </p>
        </div>

        {/* Locations Grid */}
        <div className=" w-[100%] md:w-[40%]  mx-auto">
          {data.map((location, index) => {
            const getGradient = (country) => {
              switch (country) {
                case "Nepal":
                  return "from-red-500 to-blue-500";

                case "United States of America":
                  return "from-blue-500 to-red-500";
                default:
                  return "from-blue-500 to-purple-500";
              }
            };

            return (
              <div
                key={index}
                className="group  bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-3 border border-gray-100 relative overflow-hidden"
              >
                {/* Country Flag/Gradient Background */}
                <div
                  className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br ${getGradient(
                    location.country
                  )} opacity-10 rounded-bl-full`}
                >

                </div>
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <div
                    className={`p-4 bg-gradient-to-r ${getGradient(
                      location.country
                    )} rounded-full text-white group-hover:scale-110 transition-transform duration-300`}
                  >
                    <Globe size={32} />
                  </div>
                </div>

                {/* Country Name */}
                <h3 className="text-2xl font-bold flex items-center gap-2 justify-center text-gray-900 text-center mb-6 group-hover:text-blue-600 transition-colors duration-300">
                  <p className="hidden sm:flex"> {location.country}(USA)</p>
                  <p className="sm:hidden "> USA</p>
                  <span className={`${location.icons}`} size={20} ></span>
                </h3>

                {/* Address */}
                <div className="flex  flex-col items-center justify-start space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <MapPin
                      size={30}
                      className="text-blue-600 mt-1 flex-shrink-0"
                    />
                    <div className="flex ">
                      <p className="text-gray-600 font-medium text-xl">Address:</p>
                      <a
                        href={`https://www.google.com/maps/place/${location.address},+${location.country}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-gray-800 hover:text-blue-600 transition-colors duration-300 font-semibold text-xl ml-2"
                      >
                        {location.address}
                      </a>

                    </div>
                  </div>

                  {/* Contact */}
                  {(location.contact || location.Phone) && (
                    <div className="flex items-start gap-3">

                      <div>

                        <a
                          href={`https://wa.me/${(location.contact || location.Phone)?.replace(/[^0-9]/g, '')}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-green-600 hover:text-green-900 transition-colors duration-300 font-semibold"
                          title="Chat on WhatsApp"
                        >
                          {/* <WhatsAppIcon size={50} className='text-green-600' /> */}

                        </a>
                      </div>
                    </div>
                  )}
                </div>

                {/* View on Map Button */}
                <div className="text-center">
                  <a
                    href={`https://www.google.com/maps/place/${location.address},+${location.country}`}
                    target="_blank"
                    rel="noreferrer"
                    className={`inline-flex items-center px-6 py-3 bg-gradient-to-r ${getGradient(
                      location.country
                    )} text-white font-semibold rounded-lg hover:shadow-lg transition-all duration-300 transform hover:scale-105`}
                  >
                    View on Map
                    <MapPin className="ml-2 w-4 h-4" />
                  </a>
                </div>

                {/* Hover Border Effect */}
                <div
                  className={`absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r ${getGradient(
                    location.country
                  )} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}
                ></div>
              </div>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">
            Looking to expand to new markets? Let's discuss opportunities.
          </p>
          <a
            href="/#contact"
            className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-300 shadow-lg hover:shadow-xl"
          >
            Contact Our Team
            <Phone className="ml-2 w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
}

export const data = [
  // {
  //   country: "Nepal",
  //   address: "Jhumka, Nepal",
  //   contact: "977-9709742080",
  //   icons: 'fi fi-np'
  // },
  // {
  //   country: "India",
  //   address: "Mumbai, India",
  //   contact: "977-9709742080",
  //   icons: 'fi fi-in'

  // },
  // {
  //   country: "Australia",
  //   address: "Sydney, Australia ",
  //   contact: "977-9709742080",
  //   icons: 'fi fi-au'

  // },
  {
    country: "United States of America",
    address: "Dallas, Texas, USA",
    Phone: "977-9709742080",
    icons: 'fi fi-us'

  },
];
